export default "__VITE_ASSET__DbchWTnk__"